import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=2456dd65&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Local\\OSPanel\\domains\\partner8.local\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2456dd65')) {
      api.createRecord('2456dd65', component.options)
    } else {
      api.reload('2456dd65', component.options)
    }
    module.hot.accept("./Location.vue?vue&type=template&id=2456dd65&", function () {
      api.rerender('2456dd65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Location.vue"
export default component.exports